import { signal } from "@preact/signals";
import type { Product } from "apps/commerce/types.ts";

export const selectedProducts = signal<Product[]>([]);

export function selectProduct(product: Product) {
  selectedProducts.value = [
    ...selectedProducts.value.filter((p) =>
      p.inProductGroupWithID !== product.inProductGroupWithID
    ),
    product,
  ];
}

export function unselectProduct(product: Product) {
  selectedProducts.value = selectedProducts.value
    .filter((p) => p.sku !== product.sku);
}
